import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ProjektStatiService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ProjektStatiService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ProjektStatiServiceModule {}
